import React from "react";
import { useSelector } from "react-redux";

import { getString } from "../../utilities";
import SubscriptionCard from "./SubscriptionCard";
import { routeCodes } from "../../config/routes";
import { Link } from "react-router";
import Arrow from "../../../assets/svg/arrowRight.svg";
import { roleSelector } from "../../redux/slices/loginSlice";
import { getLangCode, language, userRoles } from "../../config";

export default function SchoolPlans({ plan, setPlan, setPlanAmount, planData }) {
  const loginRole = useSelector(roleSelector);

  const renderRequestQuote = () => {
    if (loginRole === userRoles.school || getLangCode() !== language.default) {
      return null;
    }
    return (
      <p>
        <Link
          type="button"
          to={routeCodes.REQUEST_QUOTE}
          className="planbutton button-flat-color school-sub-light round auto"
        >
          {getString("subscribe.plans.school.requestQuote").toUpperCase()}
          <Arrow className="inline-arrow" />
        </Link>
      </p>
    );
  };

  return (
    <div className="wrapper plans-wrapper school">
      <div className="plans-title">{getString("subscribe.plans.school.title.1")}</div>

      {renderRequestQuote()}

      <div className="plans-subs">
        <SubscriptionCard
          plan={plan}
          setPlan={setPlan}
          setPlanAmount={setPlanAmount}
          planData={planData}
          subscription="m12"
        />
      </div>

      <div className="plans-disclaimer">{getString("subscribe.plans.disclaimer")}</div>
    </div>
  );
}
